import api from '../services/api';

/** Update a record's status via its bulk-update endpoint. */
export async function updateStatusViaBulkUpdate(bulkEndpoint, id, status) {
  const path = bulkEndpoint.startsWith('/') ? bulkEndpoint : `/${bulkEndpoint}`;
  await api.put(path, { ids: [Number(id)], status });
}

/** Backward-compatible cancellation helper used by cancellable resources. */
export const cancelViaBulkUpdate = updateStatusViaBulkUpdate;
